var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWhiteArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.393 0L9.027 7.047 1.551.157 0 1.656 9.084 10 18 1.45 16.393 0z",
    fill: "#F5F5F5"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDE4IDEwIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0xNi4zOTI5IDBMOS4wMjcwMyA3LjA0NzE0TDEuNTUwNiAwLjE1NjI2OUwxLjU0NjI4ZS0wOCAxLjY1NjQ3TDkuMDgzNTcgMTBMMTggMS40NTAyMkwxNi4zOTI5IDBaIiBmaWxsPSIjRjVGNUY1Ii8+Cjwvc3ZnPgo=";
export { SvgSmallWhiteArrow as ReactComponent };